"use client";

import React from "react";
import { Button } from "@/components/ui/button";

interface HoursQuickSelectProps {
  currentValue: string | number | undefined;
  onSelect: (value: string | number) => void;
  isNumberField?: boolean;
}

/**
 * Shared component for hours quick-select buttons.
 * Used by both text and number field renderers.
 */
export const HoursQuickSelect: React.FC<HoursQuickSelectProps> = ({
  currentValue,
  onSelect,
  isNumberField = false,
}) => {
  const options = isNumberField
    ? [
        { label: "15 min", value: 0.25 },
        { label: "30 min", value: 0.5 },
        { label: "45 min", value: 0.75 },
        { label: "1 hour", value: 1 },
      ]
    : [
        { label: "15 min", value: "0.25" },
        { label: "30 min", value: "0.5" },
        { label: "45 min", value: "0.75" },
        { label: "1 hr", value: "1" },
        { label: "2 hrs", value: "2" },
        { label: "2.5 hrs", value: "2.5" },
        { label: "3 hrs", value: "3" },
        { label: "4 hrs", value: "4" },
      ];

  return (
    <div className="flex flex-wrap gap-2 mt-2">
      <span className="text-sm text-gray-600 dark:text-gray-400 mr-2">Quick select:</span>
      {options.map((option) => (
        <Button
          key={option.value}
          type="button"
          variant={currentValue === option.value ? "default" : "outline"}
          size="sm"
          onClick={() => onSelect(option.value)}
          className="text-xs h-7 px-2"
        >
          {option.label}
        </Button>
      ))}
    </div>
  );
};
